var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { FilterData } from "path-shared/models/filter-data";
var ActuacioMatriculaFilter = /** @class */ (function (_super) {
    __extends(ActuacioMatriculaFilter, _super);
    function ActuacioMatriculaFilter(sortField, sortDir) {
        var _this = _super.call(this, sortField, sortDir) || this;
        _this.matricula = '';
        _this.datainici = new Date();
        _this.datafi = new Date();
        _this.labels['matricula'] = _this.i18n('Matricula');
        _this.labels['datainici'] = _this.i18n('Data inicial');
        _this.labels['datafi'] = _this.i18n('Data final');
        return _this;
    }
    return ActuacioMatriculaFilter;
}(FilterData));
export { ActuacioMatriculaFilter };
